import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AdminDashboardUIHelpers";

const UnknownEmailSenderUIContext = createContext();

export function useUnknownEmailSenderUIContext() {
  let scc = useContext(UnknownEmailSenderUIContext);
  return scc;
}

export const UnknownEmailSenderUIConsumer =
  UnknownEmailSenderUIContext.Consumer;

export function UnknownEmailSenderUIProvider({ customersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
  };

  return (
    <UnknownEmailSenderUIContext.Provider value={value}>
      {children}
    </UnknownEmailSenderUIContext.Provider>
  );
}
